/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateFormSectionDto } from '../models';
// @ts-ignore
import type { CreateQuestionConfigDto } from '../models';
// @ts-ignore
import type { DeleteFormQuestionConfigDto } from '../models';
// @ts-ignore
import type { DeleteFormSectionConfigDto } from '../models';
// @ts-ignore
import type { FormQuestionConfigDto } from '../models';
// @ts-ignore
import type { FormQuestionDto } from '../models';
// @ts-ignore
import type { FormSectionConfigDto } from '../models';
// @ts-ignore
import type { FormSectionDto } from '../models';
// @ts-ignore
import type { FormSectionsConfigControllerGetFormSections200Response } from '../models';
// @ts-ignore
import type { SortSectionQuestionsDto } from '../models';
// @ts-ignore
import type { UpdateFormSectionDto } from '../models';
/**
 * FormsSectionsConfigApi - axios parameter creator
 * @export
 */
export const FormsSectionsConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} sectionId 
         * @param {Array<FormQuestionConfigDto>} formQuestionConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSectionsConfigControllerAddQuestionsToForm: async (sectionId: string, formQuestionConfigDto: Array<FormQuestionConfigDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionId' is not null or undefined
            assertParamExists('formSectionsConfigControllerAddQuestionsToForm', 'sectionId', sectionId)
            // verify required parameter 'formQuestionConfigDto' is not null or undefined
            assertParamExists('formSectionsConfigControllerAddQuestionsToForm', 'formQuestionConfigDto', formQuestionConfigDto)
            const localVarPath = `/api/form-sections-config/add-form-question/{sectionId}`
                .replace(`{${"sectionId"}}`, encodeURIComponent(String(sectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(formQuestionConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateFormSectionDto} createFormSectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSectionsConfigControllerCreateFormSectionConfig: async (createFormSectionDto: CreateFormSectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFormSectionDto' is not null or undefined
            assertParamExists('formSectionsConfigControllerCreateFormSectionConfig', 'createFormSectionDto', createFormSectionDto)
            const localVarPath = `/api/form-sections-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFormSectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sectionId 
         * @param {CreateQuestionConfigDto} createQuestionConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSectionsConfigControllerCreateQuestionToSection: async (sectionId: string, createQuestionConfigDto: CreateQuestionConfigDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionId' is not null or undefined
            assertParamExists('formSectionsConfigControllerCreateQuestionToSection', 'sectionId', sectionId)
            // verify required parameter 'createQuestionConfigDto' is not null or undefined
            assertParamExists('formSectionsConfigControllerCreateQuestionToSection', 'createQuestionConfigDto', createQuestionConfigDto)
            const localVarPath = `/api/form-sections-config/create-form-question/{sectionId}`
                .replace(`{${"sectionId"}}`, encodeURIComponent(String(sectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuestionConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSectionsConfigControllerDeleteFormQuestionConfig: async (questionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('formSectionsConfigControllerDeleteFormQuestionConfig', 'questionId', questionId)
            const localVarPath = `/api/form-sections-config/form-question/{questionId}`
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSectionsConfigControllerDeleteFormSectionConfig: async (sectionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionId' is not null or undefined
            assertParamExists('formSectionsConfigControllerDeleteFormSectionConfig', 'sectionId', sectionId)
            const localVarPath = `/api/form-sections-config/{sectionId}`
                .replace(`{${"sectionId"}}`, encodeURIComponent(String(sectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSectionsConfigControllerGetFormSectionConfigDetail: async (sectionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionId' is not null or undefined
            assertParamExists('formSectionsConfigControllerGetFormSectionConfigDetail', 'sectionId', sectionId)
            const localVarPath = `/api/form-sections-config/{sectionId}`
                .replace(`{${"sectionId"}}`, encodeURIComponent(String(sectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [code] 
         * @param {string} [formId] 
         * @param {string | null} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSectionsConfigControllerGetFormSections: async (code?: string, formId?: string, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/form-sections-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (formId !== undefined) {
                localVarQueryParameter['formId'] = formId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['orderDirection'] = orderDirection;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sectionId 
         * @param {SortSectionQuestionsDto} sortSectionQuestionsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSectionsConfigControllerSortSectionQuestions: async (sectionId: string, sortSectionQuestionsDto: SortSectionQuestionsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionId' is not null or undefined
            assertParamExists('formSectionsConfigControllerSortSectionQuestions', 'sectionId', sectionId)
            // verify required parameter 'sortSectionQuestionsDto' is not null or undefined
            assertParamExists('formSectionsConfigControllerSortSectionQuestions', 'sortSectionQuestionsDto', sortSectionQuestionsDto)
            const localVarPath = `/api/form-sections-config/sort-section-questions/{sectionId}`
                .replace(`{${"sectionId"}}`, encodeURIComponent(String(sectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sortSectionQuestionsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sectionId 
         * @param {UpdateFormSectionDto} updateFormSectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSectionsConfigControllerUpdateFormSectionConfig: async (sectionId: string, updateFormSectionDto: UpdateFormSectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionId' is not null or undefined
            assertParamExists('formSectionsConfigControllerUpdateFormSectionConfig', 'sectionId', sectionId)
            // verify required parameter 'updateFormSectionDto' is not null or undefined
            assertParamExists('formSectionsConfigControllerUpdateFormSectionConfig', 'updateFormSectionDto', updateFormSectionDto)
            const localVarPath = `/api/form-sections-config/{sectionId}`
                .replace(`{${"sectionId"}}`, encodeURIComponent(String(sectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFormSectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormsSectionsConfigApi - functional programming interface
 * @export
 */
export const FormsSectionsConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormsSectionsConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} sectionId 
         * @param {Array<FormQuestionConfigDto>} formQuestionConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formSectionsConfigControllerAddQuestionsToForm(sectionId: string, formQuestionConfigDto: Array<FormQuestionConfigDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormQuestionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formSectionsConfigControllerAddQuestionsToForm(sectionId, formQuestionConfigDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsSectionsConfigApi.formSectionsConfigControllerAddQuestionsToForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateFormSectionDto} createFormSectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formSectionsConfigControllerCreateFormSectionConfig(createFormSectionDto: CreateFormSectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormSectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formSectionsConfigControllerCreateFormSectionConfig(createFormSectionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsSectionsConfigApi.formSectionsConfigControllerCreateFormSectionConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sectionId 
         * @param {CreateQuestionConfigDto} createQuestionConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formSectionsConfigControllerCreateQuestionToSection(sectionId: string, createQuestionConfigDto: CreateQuestionConfigDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormQuestionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formSectionsConfigControllerCreateQuestionToSection(sectionId, createQuestionConfigDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsSectionsConfigApi.formSectionsConfigControllerCreateQuestionToSection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formSectionsConfigControllerDeleteFormQuestionConfig(questionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteFormQuestionConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formSectionsConfigControllerDeleteFormQuestionConfig(questionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsSectionsConfigApi.formSectionsConfigControllerDeleteFormQuestionConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formSectionsConfigControllerDeleteFormSectionConfig(sectionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteFormSectionConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formSectionsConfigControllerDeleteFormSectionConfig(sectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsSectionsConfigApi.formSectionsConfigControllerDeleteFormSectionConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formSectionsConfigControllerGetFormSectionConfigDetail(sectionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormSectionConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formSectionsConfigControllerGetFormSectionConfigDetail(sectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsSectionsConfigApi.formSectionsConfigControllerGetFormSectionConfigDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [code] 
         * @param {string} [formId] 
         * @param {string | null} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formSectionsConfigControllerGetFormSections(code?: string, formId?: string, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormSectionsConfigControllerGetFormSections200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formSectionsConfigControllerGetFormSections(code, formId, search, orderBy, orderDirection, pageNumber, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsSectionsConfigApi.formSectionsConfigControllerGetFormSections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sectionId 
         * @param {SortSectionQuestionsDto} sortSectionQuestionsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formSectionsConfigControllerSortSectionQuestions(sectionId: string, sortSectionQuestionsDto: SortSectionQuestionsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormSectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formSectionsConfigControllerSortSectionQuestions(sectionId, sortSectionQuestionsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsSectionsConfigApi.formSectionsConfigControllerSortSectionQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sectionId 
         * @param {UpdateFormSectionDto} updateFormSectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formSectionsConfigControllerUpdateFormSectionConfig(sectionId: string, updateFormSectionDto: UpdateFormSectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormSectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formSectionsConfigControllerUpdateFormSectionConfig(sectionId, updateFormSectionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsSectionsConfigApi.formSectionsConfigControllerUpdateFormSectionConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FormsSectionsConfigApi - factory interface
 * @export
 */
export const FormsSectionsConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormsSectionsConfigApiFp(configuration)
    return {
        /**
         * 
         * @param {string} sectionId 
         * @param {Array<FormQuestionConfigDto>} formQuestionConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSectionsConfigControllerAddQuestionsToForm(sectionId: string, formQuestionConfigDto: Array<FormQuestionConfigDto>, options?: RawAxiosRequestConfig): AxiosPromise<Array<FormQuestionDto>> {
            return localVarFp.formSectionsConfigControllerAddQuestionsToForm(sectionId, formQuestionConfigDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateFormSectionDto} createFormSectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSectionsConfigControllerCreateFormSectionConfig(createFormSectionDto: CreateFormSectionDto, options?: RawAxiosRequestConfig): AxiosPromise<FormSectionDto> {
            return localVarFp.formSectionsConfigControllerCreateFormSectionConfig(createFormSectionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sectionId 
         * @param {CreateQuestionConfigDto} createQuestionConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSectionsConfigControllerCreateQuestionToSection(sectionId: string, createQuestionConfigDto: CreateQuestionConfigDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<FormQuestionDto>> {
            return localVarFp.formSectionsConfigControllerCreateQuestionToSection(sectionId, createQuestionConfigDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSectionsConfigControllerDeleteFormQuestionConfig(questionId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteFormQuestionConfigDto> {
            return localVarFp.formSectionsConfigControllerDeleteFormQuestionConfig(questionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSectionsConfigControllerDeleteFormSectionConfig(sectionId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteFormSectionConfigDto> {
            return localVarFp.formSectionsConfigControllerDeleteFormSectionConfig(sectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSectionsConfigControllerGetFormSectionConfigDetail(sectionId: string, options?: RawAxiosRequestConfig): AxiosPromise<FormSectionConfigDto> {
            return localVarFp.formSectionsConfigControllerGetFormSectionConfigDetail(sectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [code] 
         * @param {string} [formId] 
         * @param {string | null} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSectionsConfigControllerGetFormSections(code?: string, formId?: string, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<FormSectionsConfigControllerGetFormSections200Response> {
            return localVarFp.formSectionsConfigControllerGetFormSections(code, formId, search, orderBy, orderDirection, pageNumber, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sectionId 
         * @param {SortSectionQuestionsDto} sortSectionQuestionsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSectionsConfigControllerSortSectionQuestions(sectionId: string, sortSectionQuestionsDto: SortSectionQuestionsDto, options?: RawAxiosRequestConfig): AxiosPromise<FormSectionDto> {
            return localVarFp.formSectionsConfigControllerSortSectionQuestions(sectionId, sortSectionQuestionsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sectionId 
         * @param {UpdateFormSectionDto} updateFormSectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSectionsConfigControllerUpdateFormSectionConfig(sectionId: string, updateFormSectionDto: UpdateFormSectionDto, options?: RawAxiosRequestConfig): AxiosPromise<FormSectionDto> {
            return localVarFp.formSectionsConfigControllerUpdateFormSectionConfig(sectionId, updateFormSectionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FormsSectionsConfigApi - object-oriented interface
 * @export
 * @class FormsSectionsConfigApi
 * @extends {BaseAPI}
 */
export class FormsSectionsConfigApi extends BaseAPI {
    /**
     * 
     * @param {string} sectionId 
     * @param {Array<FormQuestionConfigDto>} formQuestionConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsSectionsConfigApi
     */
    public formSectionsConfigControllerAddQuestionsToForm(sectionId: string, formQuestionConfigDto: Array<FormQuestionConfigDto>, options?: RawAxiosRequestConfig) {
        return FormsSectionsConfigApiFp(this.configuration).formSectionsConfigControllerAddQuestionsToForm(sectionId, formQuestionConfigDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateFormSectionDto} createFormSectionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsSectionsConfigApi
     */
    public formSectionsConfigControllerCreateFormSectionConfig(createFormSectionDto: CreateFormSectionDto, options?: RawAxiosRequestConfig) {
        return FormsSectionsConfigApiFp(this.configuration).formSectionsConfigControllerCreateFormSectionConfig(createFormSectionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sectionId 
     * @param {CreateQuestionConfigDto} createQuestionConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsSectionsConfigApi
     */
    public formSectionsConfigControllerCreateQuestionToSection(sectionId: string, createQuestionConfigDto: CreateQuestionConfigDto, options?: RawAxiosRequestConfig) {
        return FormsSectionsConfigApiFp(this.configuration).formSectionsConfigControllerCreateQuestionToSection(sectionId, createQuestionConfigDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} questionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsSectionsConfigApi
     */
    public formSectionsConfigControllerDeleteFormQuestionConfig(questionId: string, options?: RawAxiosRequestConfig) {
        return FormsSectionsConfigApiFp(this.configuration).formSectionsConfigControllerDeleteFormQuestionConfig(questionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsSectionsConfigApi
     */
    public formSectionsConfigControllerDeleteFormSectionConfig(sectionId: string, options?: RawAxiosRequestConfig) {
        return FormsSectionsConfigApiFp(this.configuration).formSectionsConfigControllerDeleteFormSectionConfig(sectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsSectionsConfigApi
     */
    public formSectionsConfigControllerGetFormSectionConfigDetail(sectionId: string, options?: RawAxiosRequestConfig) {
        return FormsSectionsConfigApiFp(this.configuration).formSectionsConfigControllerGetFormSectionConfigDetail(sectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [code] 
     * @param {string} [formId] 
     * @param {string | null} [search] 
     * @param {string | null} [orderBy] 
     * @param {string | null} [orderDirection] 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsSectionsConfigApi
     */
    public formSectionsConfigControllerGetFormSections(code?: string, formId?: string, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return FormsSectionsConfigApiFp(this.configuration).formSectionsConfigControllerGetFormSections(code, formId, search, orderBy, orderDirection, pageNumber, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sectionId 
     * @param {SortSectionQuestionsDto} sortSectionQuestionsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsSectionsConfigApi
     */
    public formSectionsConfigControllerSortSectionQuestions(sectionId: string, sortSectionQuestionsDto: SortSectionQuestionsDto, options?: RawAxiosRequestConfig) {
        return FormsSectionsConfigApiFp(this.configuration).formSectionsConfigControllerSortSectionQuestions(sectionId, sortSectionQuestionsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sectionId 
     * @param {UpdateFormSectionDto} updateFormSectionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsSectionsConfigApi
     */
    public formSectionsConfigControllerUpdateFormSectionConfig(sectionId: string, updateFormSectionDto: UpdateFormSectionDto, options?: RawAxiosRequestConfig) {
        return FormsSectionsConfigApiFp(this.configuration).formSectionsConfigControllerUpdateFormSectionConfig(sectionId, updateFormSectionDto, options).then((request) => request(this.axios, this.basePath));
    }
}

